import { useParams } from "react-router";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { CalculationComponent } from "@/routes/processes/[processId]/vbs/calculations/[calculationId]/calculation/calculation-route";

export function WorkOrderPlanningCalculationRoute() {
  const { workOrderId } = useParams();
  const { data } = useVbsWorkOrderShowQuery({ id: workOrderId! });

  return (
    <CalculationComponent
      calculationId={data!.calculationId}
      defaultOpen={false}
    />
  );
}
